var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 98,
    viewBox: "0 0 84 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.2328,
    y: 22.82,
    width: 45.3243,
    height: 63.7282,
    rx: 7,
    transform: "rotate(2.5 28.2328 22.82)",
    fill: "#212121",
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.443678,
    y: 18.5311,
    width: 48.8243,
    height: 67.2282,
    rx: 8.75,
    transform: "rotate(-7.5 0.443678 18.5311)",
    fill: "#212121",
    stroke: "#2C2C2C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32937 27.1064C1.75266 22.7259 4.83624 18.7073 9.21671 18.1306L40.2731 14.0419C44.6535 13.4652 48.6721 16.5488 49.2488 20.9293L50.1779 27.9859L3.25839 34.163L2.32937 27.1064Z",
    fill: "#212121"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4102,
    y: 14.9697,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(82.5 58.4102 14.9697)",
    fill: "#FFC97A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4062,
    y: 4.08301,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(-7.5 40.4062 4.08301)",
    fill: "#FFC97A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9609,
    y: 5.87598,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(37.5 51.9609 5.87598)",
    fill: "#FFC97A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.16797,
    y: 36.1709,
    width: 38.1224,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 8.16797 36.1709)",
    fill: "#2C2C2C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.88281,
    y: 49.2041,
    width: 30.7692,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 9.88281 49.2041)",
    fill: "#2C2C2C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85547,
    y: 41.3838,
    width: 13.8029,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 8.85547 41.3838)",
    fill: "#444444"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5703,
    y: 54.417,
    width: 13.8029,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 10.5703 54.417)",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.c40a696100f41b27628c430fa97265ad.svg";
export { ForwardRef as ReactComponent };